import Places from "./Places";

export default Places;
